// @flow

export default class Features {
  bedrooms: number;
  bathrooms: number;
  parkings: number;
  squareMts: number;
  amenities: Array<any>;

  constructor(data: any = {}) {
    this.bedrooms = data.bedrooms || 0;
    this.bathrooms = data.bathrooms || 0;
    this.parkings = data.parkings || 0;
    this.squareMts = data.square_mts || 0;
    this.amenities = data.amenities || [];
  }
}
